<div class="exhibitor-contact">
  <div class="exhibitor-contact__headline">
    <planone-profile-picture [size]="84" class="contact-image">
      @if (exhibitor?.logo?.resource) {
      <img
        [src]="exhibitor?.logo?.resource | ImageUrl : exhibitor?.logo?.provider"
        [alt]="exhibitor?.name"
        class="logo" />
      } @else {
      <mat-icon class="logo__placeholder">corporate_fare</mat-icon>
      }
    </planone-profile-picture>
    @if (!hideLocation && exhibitor?.exhibition_halls) {
    <planone-location
      [exhibition_halls]="exhibitor?.exhibition_halls"
      [fair_id]="exhibitor?.fair_id"
      [locationClickable]="exhibitorClickable"></planone-location>
    }
  </div>
  <div class="contact-details">
    <h4 [class]="hideDescription ? 'mat-headline-4 mb-0' : 'mat-headline-4'">
      {{ exhibitor?.name }}
      <a [routerLink]="exhibitorClickable ? ['/fairs', exhibitor?.fair_id, 'exhibitors', exhibitor?.id] : []"
        ><mat-icon class="exhibitor__link">arrow_right_alt</mat-icon></a
      >
    </h4>
    @if (exhibitor?.description && !hideDescription) {
    <section [innerHtml]="exhibitor?.description"></section>
    }
    <p>
      @if (email || exhibitor?.contact?.email || exhibitor?.contact?.phone) { @if (!hideDescription) {
      <b i18n="@@uiElements-contact">Kontakt</b>
      <br />
      } @if (exhibitor?.contact?.phone) {
      <a
        class="exhibitor-contact__link"
        [href]="'tel:' + exhibitor?.contact?.phone"
        (click)="
          linkClick.emit({
            linkText: exhibitor?.contact?.phone,
            linkType: 'TELEPHONE_COMPANY',
            element: $event.currentTarget
          })
        "
        (middleclick)="
          linkClick.emit({
            linkText: exhibitor?.contact?.phone,
            linkType: 'TELEPHONE_COMPANY',
            element: $event.currentTarget
          })
        "
        ><mat-icon>phone_in_talk</mat-icon> {{ exhibitor?.contact?.phone }}</a
      >
      } @if (email) {
      <a
        class="exhibitor-contact__link"
        [href]="'mailto:' + email"
        (click)="linkClick.emit({ linkText: email, linkType: 'MAIL_COMPANY', element: $event.currentTarget })"
        (middleclick)="linkClick.emit({ linkText: email, linkType: 'MAIL_COMPANY', element: $event.currentTarget })"
        ><mat-icon>mail</mat-icon> {{ email }}</a
      >
      } @if (!email && exhibitor?.contact?.email) {
      <a
        class="exhibitor-contact__link"
        [href]="'mailto:' + exhibitor?.contact?.email"
        (click)="
          linkClick.emit({
            linkText: exhibitor?.contact?.email,
            linkType: 'MAIL_COMPANY',
            element: $event.currentTarget
          })
        "
        (middleclick)="
          linkClick.emit({
            linkText: exhibitor?.contact?.email,
            linkType: 'MAIL_COMPANY',
            element: $event.currentTarget
          })
        "
        ><mat-icon>mail</mat-icon> {{ exhibitor?.contact?.email }}</a
      >
      } }
    </p>
  </div>
</div>
